export const types = {
    getUsuarios: '[CHAT] GET_USUARIOS',
    activarChat: '[CHAT] ACTIVE_CHAT',
    nuevoMensaje: '[CHAT] NUEVO_MENSAJE',
    setMensajes: '[CHAT] SET_MENSAJES',
    resetState: '[CHAT] RESET_STATE'
}